module.exports = require("@swa-ui/core/src/Stepper/Stepper.module.scss");